import styled from 'styled-components';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';

export const Container = styled.div`
  display: none;

  ${media.mediumHigh`
    padding-bottom: 1rem;
    padding-right: 1.5rem;
  `}
  ${media.mediumDesktop`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem 2rem;
  `}
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
export const Link = styled.a`
  color: ${colors.pacificBlue};
  text-decoration: none;
`;
